import { render } from "./TheInvoicesContainer.vue?vue&type=template&id=ae4fc7c4"
import script from "./TheInvoicesContainer.vue?vue&type=script&lang=js"
export * from "./TheInvoicesContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__